import Logo from '../../components/Logo';

/** The split sign-in canvas from the design: brand panel left, form right. */
export default function AuthLayout({ children, wide = false }) {
  return (
    <div className="auth">
      <div className="auth-brand">
        <div>
          <div className="auth-logo">
            <Logo height={64} tagline />
          </div>
          <div className="auth-kicker">Fountainhead Publishing</div>
        </div>
        <div className="auth-lead">
          <h1>
            One login.
            <br />
            Five roles.
            <br />
            Every title.
          </h1>
          <p>
            Fountainhead Online Content &amp; User Support — the operations console for teacher
            verification, school adoption, licence activation and the resource repository.
          </p>
        </div>
      </div>
      <div className="auth-form-col">
        <div className={`auth-form${wide ? ' auth-wide' : ''}`}>{children}</div>
      </div>
    </div>
  );
}
